import {ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {ThingFeatureInterface} from '@app/app/shared/interfaces/thing/thing-feature.interface';
import {CommandsService} from '@app/app/shared/services/commands.service';
import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

@Component({
  templateUrl: './park-feature-control.html',
  selector: 'park-feature-control'
})

export class ParkFeatureControlComponent implements OnDestroy {
  @Input() public feature: ThingFeatureInterface;
  @Input() public featureId: string;
  @Input() public parkId: string;
  @Input() public id: string;

  public isRunningAuto = false;
  public isRunningManual = false;
  public isRunningOff = false;
  public isRunningRed = false;
  public isRunningGreen = false;
  public isRunningBlue = false;
  public isRunningWhite = false;

  private timerSub: Subscription;

  private MODE_AUTO = 'auto';
  private MODE_MANUAL = 'manu';
  private MODE_OFF = 'off';
  private MODE_RED = 'red';
  private MODE_GREEN = 'green';
  private MODE_BLUE = 'blue';
  private MODE_WHITE = 'white';

  constructor(private comm: CommandsService, private cdRef: ChangeDetectorRef) {
    //
  }

  public values(obj: object) {
    return Object.values(obj);
  }

  /**
   * Set mode to auto
   */
  public setModeAuto() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningAuto = true;
      this.update(this.MODE_AUTO);
    }
  }

  /**
   * Set mode to manual
   */
  public setModeManual() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningManual = true;
      this.update(this.MODE_MANUAL);
    }
  }

  /**
   * Set mode to red
   */
  public setModeRed() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningRed = true;
      this.update(this.MODE_RED);
    }
  }

  /**
   * Set mode to green
   */
  public setModeGreen() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningGreen = true;
      this.update(this.MODE_GREEN);
    }
  }

  /**
   * Set mode to blue
   */
  public setModeBlue() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningBlue = true;
      this.update(this.MODE_BLUE);
    }
  }

  /**
   * Set mode to white
   */
  public setModeWhite() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningWhite = true;
      this.update(this.MODE_WHITE);
    }
  }

  /**
   * Set mode to off
   */
  public setModeOff() {
    // Do not send command if another one is running
    if (!this.isRunning()) {
      this.isRunningOff = true;
      this.update(this.MODE_OFF);
    }
  }

  public isAuto() {
    const isAuto = (this.feature.md === this.MODE_AUTO);

    if (isAuto && this.isRunningAuto) {
      this.isRunningAuto = false;
      this.cdRef.detectChanges();
    }

    return isAuto;
  }

  public isManual() {
    const isManual = (this.feature.md === this.MODE_MANUAL);

    if (isManual && this.isRunningManual) {
      this.isRunningManual = false;
      this.cdRef.detectChanges();
    }

    return isManual;
  }

  public isRed() {
    const isRed = (this.feature.md === this.MODE_RED);

    if (isRed && this.isRunningRed) {
      this.isRunningRed = false;
      this.cdRef.detectChanges();
    }

    return isRed;
  }

  public isGreen() {
    const isGreen = (this.feature.md === this.MODE_GREEN);

    if (isGreen && this.isRunningGreen) {
      this.isRunningGreen = false;
      this.cdRef.detectChanges();
    }

    return isGreen;
  }

  public isBlue() {
    const isBlue = (this.feature.md === this.MODE_BLUE);

    if (isBlue && this.isRunningBlue) {
      this.isRunningBlue = false;
      this.cdRef.detectChanges();
    }

    return isBlue;
  }

  public isWhite() {
    const isWhite = (this.feature.md === this.MODE_WHITE);

    if (isWhite && this.isRunningWhite) {
      this.isRunningWhite = false;
      this.cdRef.detectChanges();
    }

    return isWhite;
  }

  public isOff() {
    const isOff = (this.feature.md === this.MODE_OFF);

    if (isOff && this.isRunningOff) {
      this.isRunningOff = false;
      this.cdRef.detectChanges();
    }

    return isOff;
  }

  public isRunning() {
    return (this.isRunningAuto || this.isRunningManual || this.isRunningOff
      || this.isRunningRed || this.isRunningGreen || this.isRunningBlue || this.isRunningWhite);
  }

  public getName = (features: ThingFeatureInterface[]) => features[Object.keys(features)[0]].nm

  /**
   * Update activator
   */
  private update(mode: string) {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }

    this.comm.setActivatorMode(this.parkId, this.id, this.featureId, mode).then((res) => {
      this.timerSub = Observable.of(true).delay(8000).subscribe(() => {
        if (this.isRunningAuto && !this.isAuto()) {
          alert('Timed Out');
        }

        if (this.isRunningManual && !this.isManual()) {
          alert('Timed Out');
        }

        if (this.isRunningOff && !this.isOff()) {
          alert('Timed Out');
        }

        if (this.isRunningRed && !this.isRed()) {
          alert('Timed Out');
        }

        if (this.isRunningGreen && !this.isGreen()) {
          alert('Timed Out');
        }

        if (this.isRunningBlue && !this.isBlue()) {
          alert('Timed Out');
        }

        if (this.isRunningWhite && !this.isWhite()) {
          alert('Timed Out');
        }

        [
          this.isRunningAuto,
          this.isRunningManual,
          this.isRunningOff,
          this.isRunningRed, 
          this.isRunningGreen,
          this.isRunningBlue,
          this.isRunningWhite
        ] = [false, false, false, false, false, false, false];
      });
    }).catch((err) => {
      [
        this.isRunningAuto,
        this.isRunningManual,
        this.isRunningOff,
        this.isRunningRed, 
        this.isRunningGreen,
        this.isRunningBlue,
        this.isRunningWhite
      ] = [false, false, false, false, false, false, false];

      alert(err);
    });
  }

  ngOnDestroy() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/features/features/control/park-feature-control.component.ts